import { t } from "i18next";
import type { NoteTypes } from "@/services/api/entities/note/types";

export const getTypeName = (noteType: NoteTypes) => {
  switch (noteType) {
    case "DEFAULT_COMMITMENT": {
      return t("common.noteType.commitment", { count: 2 }).toLowerCase();
    }
    case "DEFAULT_NOTE": {
      return t("common.noteType.note", { count: 2 }).toLowerCase();
    }
    case "DEFAULT_IDEA": {
      return t("common.noteType.idea", { count: 2 }).toLowerCase();
    }
    default: {
      return t("common.noteType.note", { count: 2 }).toLowerCase();
    }
  }
};
